<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6">
          <v-dialog
              ref="startModal"
              v-model="startModal"
              :return-value.sync="start"
              persistent
              width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  :value="computedStartDate"
                  label="Choose Start Date to query from"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  @click:clear="start = null"
                  clearable
              ></v-text-field>
            </template>
            <v-date-picker v-model="start" scrollable>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="startModal = false">Cancel</v-btn>
              <v-btn text color="primary" @click="$refs.startModal.save(start)">OK</v-btn>
            </v-date-picker>
          </v-dialog>

          <v-dialog
              ref="endModal"
              v-model="endModal"
              :return-value.sync="end"
              persistent
              width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  :value="computedEndDate"
                  label="Choose End Date to query from"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  @click:clear="end = null"
                  clearable
              ></v-text-field>
            </template>
            <v-date-picker v-model="end" scrollable>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="endModal = false">Cancel</v-btn>
              <v-btn text color="primary" @click="$refs.endModal.save(end)">OK</v-btn>
            </v-date-picker>
          </v-dialog>
        <v-autocomplete @change="setPeriodSearch" v-model="periodDate" label="Select Period" class="ml-3" :items="periods" item-value="startDate" item-text="name" />
      </v-col>
      <v-col cols="12" sm="3">
        <v-select prepend-icon="mdi-account" clearable v-model="technician" label="Select Technician for Commission Report" item-text="name" item-value="name" :items="appTechnicians" />
        <v-checkbox v-model="allTechs" label="Select all technicians"></v-checkbox>
        <v-checkbox v-model="unlocked" label="Include unlocked"></v-checkbox>
      </v-col>
      <v-col cols="12" sm="3">
        <v-btn :loading="loading" :disabled="loading" @click="getData" color="primary" large class="ml-3">View Report</v-btn>
      </v-col>
      <v-col cols="12" sm="12">
        <h6 v-if="!allTechs">Total for period {{accounting.formatMoney(sumTotal(), '£', 2)}}</h6>
        <h6 v-if="allTechs">Total Approved {{accounting.formatMoney(totalApproved, '£', 2)}}</h6>
        <h6 v-if="allTechs">Total Not Approved {{accounting.formatMoney(totalNotApproved, '£', 2)}}</h6>
        <h6 v-if="allTechs">Everything {{accounting.formatMoney(diff, '£', 2)}}</h6>
        <v-btn color="secondary" @click="printPdf">Download</v-btn>
        <v-data-table group-by="_id.valet" ref="myTable" hide-default-footer v-if="data.length > 0" :headers="headers" :items="data" class="elevation-1 mt-5" :items-per-page="5000">
          <template v-slot:item._id.startDate="{item}">
            <span> {{ item._id.startDate | moment('DD/MM/YYYY') }} </span>
          </template>
          <template v-slot:item.total17="{item}">
            <span> {{ accounting.formatMoney(item.total17, '£', 2) }} </span>
          </template>
          <template v-slot:item.total30="{item}">
            <span> {{ accounting.formatMoney(item.total30, '£', 2) }} </span>
          </template>
          <template v-slot:item.total40="{item}">
            <span> {{ accounting.formatMoney(item.total40, '£', 2) }} </span>
          </template>
          <template v-slot:item.total60="{item}">
            <span> {{ accounting.formatMoney(item.total60, '£', 2) }} </span>
          </template>
          <template v-slot:item.total100="{item}">
            <span> {{ accounting.formatMoney(item.total100, '£', 2) }} </span>
          </template>
          <template v-slot:item.totalCommission="{item}">
            <span> {{ accounting.formatMoney(item.totalCommission, '£', 2) }} </span>
          </template>
          <template v-slot:item.totalValueApproved="{item}">
            <span> {{ accounting.formatMoney(item.totalValueApproved, '£', 2) }} </span>
          </template>
          <template v-slot:item.totalValueNotApproved="{item}">
            <span> {{ accounting.formatMoney(item.totalValueNotApproved, '£', 2) }} </span>
          </template>
          <template v-slot:item.diff="{item}">
            <span v-if="item.totalValueNotApproved > 0"> {{ accounting.formatMoney(item.totalValueApproved + item.totalValueNotApproved, '£', 2) }} </span>
            <span v-if="item.totalValueNotApproved === 0"> {{ accounting.formatMoney(0, '£', 2) }} </span>

          </template>
          <template v-slot:item.documents="{item}">
            <div v-for="(d, index) in item.documents" :key="index">
              <v-card v-if="d.xeroInvoiceNumber">
                <v-card-text>
                  <p>{{d.xeroInvoiceNumber}} - {{d.xeroAccountName}} - {{d.customer.name}} <span v-if="d.customer.companyName && d.customer.companyName !== d.customer.name">({{d.customer.companyName}})</span> - {{accounting.formatMoney(d.price, '£', 2)}}</p>

                  <p><strong :style="{color: d.isApproved ? '' : 'red'}">Locked? {{d.isApproved ? 'Yes': 'No'}}</strong></p>
                </v-card-text>
              </v-card>
            </div>

          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapMutations, mapState} from "vuex";
import {ReportsHttp} from "@/http/ReportsHttp";
import accounting from 'accounting';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import {PeriodsHttp} from "@/http/PeriodsHttp";

export default {
  name: "Commission",
  computed: {
    ...mapState("technicians", ["appTechnicians"]),
    computedStartDate () {
      return this.start ? this.$moment(this.start).format('DD/MM/YYYY') : ''
    },
    computedEndDate () {
      return this.end ? this.$moment(this.end).format('DD/MM/YYYY') : ''
    },
  },
  watch: {
    periodDate(newVal) {
      this.date = this.$moment(newVal).format('YYYY-MM-DD');
    },
    start(oldVal, newVal) {
      if (oldVal !== newVal) {
        this.periodSearch = false;
      }
    },
    end(oldVal, newVal) {
      if (oldVal !== newVal) {
        this.periodSearch = false;
      }
    }
  },
  async mounted() {
    this.periods = await PeriodsHttp.getPeriods().then(result => result.data);
    this.periodDate = await PeriodsHttp.getPeriodByDate(this.$moment().format('YYYY-MM-DD')).then(result => result.data.startDate);
  },
  data() {
    return {
      periods: [],
      start: null,
      end: null,
      startModal: false,
      endModal: false,
      technician: '',
      loading: false,
      data: [],
      periodDate: '',
      headers: [
        { text: 'Date', value: '_id.startDate', groupable: false, },
        { text: 'Bookings', value: 'documents', groupable: false, },
        { text: '17.5%', value: 'total17', groupable: false, },
        { text: '30%', value: 'total30', groupable: false, },
        { text: '40%', value: 'total40', groupable: false, },
        { text: '60%', value: 'total60', groupable: false, },
        { text: '100%', value: 'total100', groupable: false, },
        { text: 'Total Commission', value: 'totalCommission', groupable: false, },
      ],
      accounting: accounting,
      totalCommission: 0,
      allTechs: false,
      unlocked: false,
      totalApproved: 0,
      totalNotApproved: 0,
      diff: 0,
      date: new Date().toISOString().substr(0, 10),
      periodSearch: true
    }
  },
  methods: {
    ...mapMutations("app", ["setToast"]),
    setPeriodSearch() {
        this.periodSearch = true;
    },
    async getData() {
      this.headers = [
        { text: 'Date', value: '_id.startDate', groupable: false, },
        { text: 'Bookings', value: 'documents', groupable: false, },
        { text: '17.5%', value: 'total17', groupable: false, },
        { text: '30%', value: 'total30', groupable: false, },
        { text: '40%', value: 'total40', groupable: false, },
        { text: '60%', value: 'total60', groupable: false, },
        { text: '100%', value: 'total100', groupable: false, },
        { text: 'Total Commission', value: 'totalCommission', groupable: false, },
      ];
      this.data = [];
      if (this.allTechs) {
        this.technician = 'all';
      }
      if (this.technician !== '') {
        try {
          this.loading = true;
          this.data = [];
          this.totalApproved = 0;
          this.totalNotApproved = 0;
          this.diff = 0;
          if (this.allTechs) {
            this.headers.push(
                { text: 'Total Approved', value: 'totalValueApproved', groupable: false, },
                { text: 'Total Not Approved', value: 'totalValueNotApproved', groupable: false, },
                { text: 'Everything', value: 'diff', groupable: false, },
            )
          } else {
            this.headers = [
              { text: 'Date', value: '_id.startDate', groupable: false, },
              { text: 'Bookings', value: 'documents', groupable: false, },
              { text: '17.5%', value: 'total17', groupable: false, },
              { text: '30%', value: 'total30', groupable: false, },
              { text: '40%', value: 'total40', groupable: false, },
              { text: '60%', value: 'total60', groupable: false, },
              { text: '100%', value: 'total100', groupable: false, },
              { text: 'Total Commission', value: 'totalCommission', groupable: false, },
            ]
          }

          if (this.periodSearch) {
            this.start = this.date;
            this.end = this.$moment(this.start).add(6, 'days').format('YYYY-MM-DD');
          }

          this.data = await ReportsHttp.getTechCommission(this.start, this.end, this.technician, this.unlocked).then(result => result.data);
          this.periodSearch = false;
          if (this.allTechs) {
            this.totalApproved = 0;
            this.totalNotApproved = 0;
            this.diff = 0;
            this.data.forEach(d => {
              this.totalApproved = this.totalApproved + d.totalApprovalLessDeductions;
              this.totalNotApproved = this.totalNotApproved + d.totalValueNotApproved;
              this.diff = this.totalApproved + this.totalNotApproved;
            });
          }

        } catch (e) {
          this.setToast({color: 'error', text: e.response.data, show: true})
        } finally {
          this.loading = false;
        }
      }
    },
    sumTotal() {
      let totalCommission = 0;
      this.data.forEach(d => {
        totalCommission = totalCommission + d.totalCommission;
      });
      return totalCommission;
    },
    printPdf() {
      const source =  this.$refs["myTable"];
      let rows = [];
      let columnHeader = ['Technician','Date', 'Bookings', '17.5%','30%', '40%', '60%', '100%', 'Total Commission'];
      let pdfName = "";
      if (this.allTechs) {
        pdfName = `Commission report for all technicians - ${this.$moment(this.start).format('DD/MM/YYYY')} - ${this.$moment(this.end).format('DD/MM/YYYY')}`;
      } else {
        pdfName = `Commission report for ${this.technician} - ${this.$moment(this.start).format('DD/MM/YYYY')} - ${this.$moment(this.end).format('DD/MM/YYYY')}`;
      }

      source.items.forEach(element => {
        let flatMapOfBookings = [];
        element.documents.forEach(d => {
            flatMapOfBookings.push(d.xeroInvoiceNumber);
        });
        let temp = [
          element._id.valet,
          this.$moment(element._id.startDate).format('DD/MM/YYYY'),
          flatMapOfBookings.toString(),
          this.accounting.formatMoney(element.total17, '£', 2),
          this.accounting.formatMoney(element.total30, '£', 2),
          this.accounting.formatMoney(element.total40, '£', 2),
          this.accounting.formatMoney(element.total60, '£', 2),
          this.accounting.formatMoney(element.total100, '£', 2),
          this.accounting.formatMoney(element.totalCommission, '£', 2),
        ];
        rows.push(temp);
      });

      const doc = new jsPDF();
      if (this.allTechs) {
        doc.text(`Total Turnover - ${this.accounting.formatMoney(this.totalApproved, '£', 2)}`, 10, 10);
      } else {
        doc.text(`Total Commission - ${this.accounting.formatMoney(this.sumTotal(), '£', 2)}`, 10, 10);
      }

      doc.autoTable(columnHeader, rows, { startY: 20 });
      doc.save(pdfName + '.pdf');
    }
  }
}
</script>
